import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=54b064d8&scoped=true&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=54b064d8&prod&lang=less&scoped=true&"
import style1 from "./UserProfile.vue?vue&type=style&index=1&id=54b064d8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b064d8",
  null
  
)

export default component.exports